
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The features supported by an ad product.`}</p>
    <p>{`These are features that have a dynamic impact on an integration partner's job posting flow.
Ad products may have additional features that are implemented entirely within SEEK's systems.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;